import React, { Component } from 'react';
import './Site.css';
import { Row, Col, Button, Input, ButtonGroup, Alert as Alert2, Table, UncontrolledTooltip, Collapse } from "reactstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classnames from "classnames";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import _ from "lodash";
import { api, dateHelper, filterHelper } from "../helpers";
import { Pager} from "../components";
import Alert from "react-s-alert";
import Select from "react-select";

const UCToolTip = (props) => {
  return (
    <UncontrolledTooltip
      placement={props.placement}
      target={props.target}
      data-html="true"
    >
      {props.text}
    </UncontrolledTooltip>
  );
};

const getProductionPlanCategories = () => api.fetch('Reference/ProductionPlanCategoriesForPlanning').then(response => {
  return {
    productPlanCategoryList: response.data
  };
}).catch(x => console.error(x));

const getProductTypes = () =>
  api
    .fetch("Reference/ProductTypes")
    .then(response => {
      var list = response.data;
      if (response.data.length > 0) {
        list = _.map(list, item => {
          item.value = item.id;
          item.label = item.name;
          delete item.id;
          delete item.name;
          return item;
        });
        list.unshift({ label: "Clear", value: null });
      }
      return {
        productTypeList: list
      };
    })
    .catch(x => console.error(x));

const emptyProductionPlan = (selectedWeekDaysList, categoryList, startDate, endDate) => {
  var list = []
  var itemCount = 0;
  _.each(selectedWeekDaysList, l => {
    _.each(categoryList, c => {
      list.push({
        id: (-1 * (itemCount + 1)),
        productionPlanId: 0,
        productionPlanCategoryId: c.id,
        itemDate: dateHelper.formatStringDate(l),
        itemName: '',
        editing: false
      })
      itemCount++;
    })
  })
  let plan = {
    id: 0,
    startDate: startDate,
    endDate: endDate,
    productionPlanItems: [] 
  }
  return plan;
}

const sortList = [
  {
    value: null,
    label: "Clear",
    sortAscending: true,
    sortColumn: ""
  },
  {
    value: 1,
    label: "Days On Hand Ascending",
    sortAscending: true,
    sortColumn: "DaysOnHand"
  },
  {
    value: 2,
    label: "Days On Hand Descending",
    sortAscending: false,
    sortColumn: "DaysOnHand"
  }
];

const resolveSelectedSortValue = (list, sortColumn, sortAscending) => {
  const sortDirection = sortAscending ? "Ascending" : "Descending";
  return _.find(list, item => {
    return (
      item.sortAscending === sortAscending &&
      item.sortColumn === sortColumn &&
      item.label.includes(sortDirection)
    );
  });
};

const resolveItemsList = (categoryId, day, itemsList) => {
  const date = dateHelper.formatStringDate(day);
  var list = _.filter(itemsList, i => {
      return i.productionPlanCategoryId === categoryId
        && dateHelper.formatStringDate(i.itemDate) === date;
      });
  return list;
}

export default class ProductionPlanning extends Component {
  static displayName = ProductionPlanning.name;
  constructor(props) {
    super(props);
    this.state = {
      message: null,
      messageColor: null,
      isMessageVisible: false,
      itemCount: 0,
      productionDate: null,
      productPlanCategoryList: [],
      productTypeList: [],
      selectedDate: null,
      startDate: null,
      endDate: null,
      selectedWeekDays: [],
      editProductionPlan: null,
      editPlanItem: null,
      missingCategories: false,
      pendingProductsList: null,
      filters: [{
        filterName: "activeOnly",
        value: true,
        filteredDisplay: "Active Only"
      }],
      sortColumn: "DaysOnHand",
      sortAscending: true,
      selectedPendingProductId: null,
      collapsePending: false
    }
    this.checkProductionCategoryList = this.checkProductionCategoryList.bind(this);
    this.onDateChange = this.onDateChange.bind(this);
    this.getPlanningData = this.getPlanningData.bind(this);
    this.isFormValid = this.isFormValid.bind(this);
    this.onSavePlan = this.onSavePlan.bind(this);
    this.clearFilters = this.clearFilters.bind(this);
    this.onChangeFilter = this.onChangeFilter.bind(this);
    this.setPage = this.setPage.bind(this);
    this.getPendingProducts = this.getPendingProducts.bind(this);
    this.ondrop = this.ondrop.bind(this);
    this.allowDrop = this.allowDrop.bind(this);
    this.onSelectChange = this.onSelectChange.bind(this);
  }

  componentDidMount() {
    Promise.all([getProductionPlanCategories(), getProductTypes()]).then(response => {
      let newStatus = {};
      _.each(response, r => Object.assign(newStatus, r));
      this.setState(newStatus, () => {
        this.checkProductionCategoryList();
      });
    });
  }

  checkProductionCategoryList() {
    if (this.state.productPlanCategoryList && this.state.productPlanCategoryList.length <= 0) {
      this.setState({
        missingCategories: true
      })
    }
  }

  getPendingProducts(sortColumn, sortAscending, filters, pageNumber) {
    const resolvedFilters = filters || this.state.filters;
    const resolvedSort = {
      sortColumn: sortColumn || this.state.sortColumn,
      sortAscending: sortAscending || this.state.sortAscending
    };
    const payload = {
      activeOnly: null,
      planningDate: this.state.startDate,
      name: null,
      ...resolvedSort,
      ...filterHelper.filtersToObject(resolvedFilters),
      pageSize: 3,
      page: pageNumber || (this.state.pagedList ? this.state.pagedList.pageNumber : 1)
    };
    api.post("Product/GetProductionPlanningPendingItemsList", payload)
      .then(response => {
        if (response && response.data) {
          this.setState({
            ...resolvedSort,
            pendingProductsList: {
              list: response.data.dataSource,
              pageNumber: response.data.page,
              pageSize: response.data.pageSize,
              totalItems: response.data.totalItems,
              totalPages: response.data.totalPages
            },
            filters: resolvedFilters,
            message: null,
            messageColor: null,
            isMessageVisible: false,
            selectedPendingProductId: null
          });
        }
      })
  }

  onDeletePending(id) {
    if (!window.confirm(`Are you sure you'd like to delete this product from pending items?`)) return;
    api.delete(`Product/RemoveProductToProductionPlanning/${id}`)
      .then(response => {
        if (response.data && response.data.success) {
          Alert.success("Product was removed from pending items.")
          this.getPendingProducts();
        } else {
          Alert.error("An error occurred. Product cannot be removed at this time.")
        }
      })
  }

  clearFilters() {
    const filters = [];
    this.setState({ filters: filters });
    this.getPendingProducts(null, null, filters);
  }

  onChangeFilter(changedFilter) {
    const filters = filterHelper.getFilters(
      this.state.filters,
      changedFilter
    );
    this.setState({ filters: filters });
    this.getPendingProducts(null, null, filters, 1);
  }

  setPage(page) {
    this.getPendingProducts(null, null, null, page);
  }

  onDismiss() {
    this.setState({
      isMessageVisible: !this.state.isMessageVisible,
      message: null,
      messageColor: null
    });
  }

  getPlanningData() {
    let payload = {
      StartDate: this.state.startDate,
      EndDate: this.state.endDate
    }
    api.post("Product/GetWeeklyPlanningData", payload)
      .then(response => {
        var list = !response.data
          ? emptyProductionPlan(
            this.state.selectedWeekDays,
            this.state.productPlanCategoryList,
            this.state.startDate, this.state.endDate)
          : response.data;
          
        if (response) {
          this.setState({
            editProductionPlan: list,
            itemCount: !response.data
              ? list.productionPlanItems.length + 1
              : 0
          }, () => { this.getPendingProducts()})
        }
      })
  }

  onDateChange(selectedDate) {
    const selected = new Date(selectedDate);
    // get week
    let dates = dateHelper.getPlanningWeekRange(selectedDate);
    this.setState({
      selectedDate: selected,
      startDate: dates.startDate,
      endDate: dates.endDate,
      selectedWeekDays: dates.list
    }, () => this.getPlanningData());
  }

  generateTableHeader() {
    const list = this.state.productPlanCategoryList.slice()
    let columns = [];
    _.each(list, item => {
      columns.push(<th className="centerText columnWidth" key={item.id}>{item.name}</th>)
    });
    columns.unshift(<th key={0} className="emptyTableHeaderCell"></th>);
    return columns;
  };

  onEdit(itemId, item) {
    let list = this.state.editProductionPlan.productionPlanItems.slice();
    const editItemIndex = _.findIndex(list, l => {
      return l.id === itemId;
    });
    list[editItemIndex].editing = true;
    this.setState({
      editPlanItem: item,
      editProductionPlan: {
        ...this.state.editProductionPlan,
        productionPlanItems: list
      }
    })
  }

  onInputChange(e) {
    this.setState({
      editPlanItem: { ...this.state.editPlanItem, [e.target.name]: e.target.value }
    });
  }

  onAddNewItem(date, categoryId) {
    let list = this.state.editProductionPlan.productionPlanItems.slice();
    let item = Object.assign({}, this.state.editPlanItem);
    if (item.itemName !== '') {
      const editItemIndex = _.findIndex(list, l => {
        return l.id === item.id;
      });
      list[editItemIndex] = item;
      list[editItemIndex].editing = false;
    } else {
      list = _.reject(list, i => { return i.id === item.id });
    }
    let count = this.state.itemCount + 1;
    var newItem = {
      id: (-1 * count),
      ProductionPlanId: this.state.editProductionPlan.id,
      productionPlanCategoryId: categoryId,
      itemDate: dateHelper.formatStringDate(date),
      itemName: this.state.selectedPendingProductSku || '',
      editing: true
    };
    list.push(newItem);
    this.setState({
      editPlanItem: newItem,
      itemCount: count,
      selectedPendingProductSku: "",
      editProductionPlan: {
        ...this.state.editProductionPlan,
        productionPlanItems: list
      }
    }, () => { this.itemNameInput.focus();});
  }

  isFormValid() {
    let warnings = [];
    if (this.state.editProductionPlan.productionPlanItems.length <= 0) {
      warnings.push("Please add item to plan before saving");
    }
    this.setState({ message: (warnings.length ? warnings.join(", ") : null), messageColor: "danger", isMessageVisible: true });
    return warnings.length === 0;
  }

  onSaveItem() {
    
    let list = this.state.editProductionPlan.productionPlanItems.slice();
    let item = Object.assign({}, this.state.editPlanItem);
    if (item.itemName !== '') {
      const editItemIndex = _.findIndex(list, l => {
        return l.id === item.id;
      });
      list[editItemIndex] = item;
      list[editItemIndex].editing = false;
    } else {
      list = _.reject(list, i => { return i.id === item.id });
    }
    this.setState({
      editPlanItem: null,
      editProductionPlan: {
        ...this.state.editProductionPlan,
        productionPlanItems: list
      }
    });
  }

  onSavePlan(isFinalize) {
    if (!this.isFormValid()) return;

    let plan = Object.assign({}, this.state.editProductionPlan);

    var itemsList = _.reject(plan.productionPlanItems, item => {
      return item.id < 0 && item.itemName.trim() === '';
    });

    let payload = {
      StartDate: dateHelper.formatDateForServer(plan.startDate),
      EndDate: dateHelper.formatDateForServer(plan.endDate),
      IsFinalize: isFinalize,
      ProductionPlanItems: _.map(itemsList, i => {
        i.Id = i.id;
        i.ItemDate = dateHelper.formatDateForServer(i.itemDate);
        i.ItemName = i.itemName;
        i.ProductionPlanCategoryId = i.productionPlanCategoryId;
        i.ProductionPlanId = i.productionPlanId;
        delete i.id;
        delete i.itemDate;
        delete i.itemName;
        delete i.productionPlanCategoryId;
        delete i.productionPlanId;
        return i;
      })
    }

    if (plan.id > 0) {
      payload.Id = plan.id;
    }

    api.post("Product/SaveProductionPlanningForm", payload)
      .then(response => {
        if (response.data.success) {
          Alert.success(`Plan Saved for ${dateHelper.formatStringDate(plan.startDate, 'MM.DD.YYYY')}.`)
          this.getPlanningData();
        } else {
          Alert.error(`An error occurred. Production plan for ${dateHelper.formatStringDate(plan.startDate, 'MM.DD.YYYY')} cannot be saved at this time.`)
        }
      }).catch(error => Alert.error(`There was an error saving production plan.`));
  }

  downloadReport() {
    let plan = Object.assign({}, this.state.editProductionPlan);

    let payload = {
      Id: plan.id,
      StartDate: dateHelper.formatDateForServer(plan.startDate),
      EndDate: dateHelper.formatDateForServer(plan.endDate),

    }
    api.postFormDataGetBlob("Product/ExportProductionPlan", payload)
      .then(response => {
      if (response.status === 200) {
        const XLSX_MIME = "application/vnd.openxmlformats-officedocument.spreadsheetml";
        const XLSX_FILENAME = `production_planning_${dateHelper.formatStringDate(plan.startDate, 'MM.DD.YYYY')}.xlsx`;
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(response.data, XLSX_FILENAME);
        }
        else {
          const file = new Blob([response.data], { type: XLSX_MIME });
          var anchor = window.document.createElement('a');
          anchor.download = XLSX_FILENAME;
          anchor.href = (window.webkitURL || window.URL).createObjectURL(file);
          anchor.dataset.downloadurl = [XLSX_MIME, anchor.download, anchor.href].join(':');
          anchor.click();
        }
      } else {
        throw new Error("Error downloading report");
      }
    }).catch(error => Alert.error(error));
  }

  drag(event, productId, value) {
    event.dataTransfer.setData("number", productId);
    this.setState({ selectedPendingProductId: productId, selectedPendingProductSku: value})
  }

  ondrop(event, date, category) {
    event.preventDefault();
    this.onAddNewItem(date,category)
  }

  allowDrop(event) {
    event.preventDefault();
  }

  ondragstart(event){
    event.dataTransfer.setData("text", event.target.id);
  }

  collapsePending() {
    this.setState({ collapsePending: !this.state.collapsePending });
  }

  onSelectChange(selection) {
    this.setState(
      {
        sortColumn: selection.sortColumn,
        sortAscending: selection.sortAscending
      },
      () => {
        this.getPendingProducts(
          selection.sortColumn,
          selection.sortAscending,
          null,
          null
        );
      }
    );
  }

  render() {
    const prodPlan = this.state.editProductionPlan !== null ? this.state.editProductionPlan : null;
    return (
      <div className="ml-4 mr-4">
        <Row className="pageTitle p-2">
          <Col className="blueText"><h4 >Production Planning</h4></Col>
          <Col xs="1" className="float-right p-0 m-0">
            <DatePicker
              selected={this.state.selectedDate}
              className="form-control pageTitleItem float-right mr-2"
              placeholderText="Select a date"
              onChange={this.onDateChange}
              disabled={this.state.missingCategories || (this.state.productPlanCategoryList && !this.state.productPlanCategoryList.length)}
            />
          </Col>
          <Col xs="1" className="p-0 ml-2">
            {prodPlan ? (
              <ButtonGroup>
                <Button size="sm" title="Save for Later" color="primary" className="buttonGroupSpacing float-right" onClick={() => this.onSavePlan(false)}><FontAwesomeIcon icon="save" /></Button>
                {!prodPlan.publishedAt ? (
                  <Button size="sm" title="Finalize" color="success" className="buttonGroupSpacing float-right" onClick={() => this.onSavePlan(true)}><FontAwesomeIcon icon="clipboard-check" /></Button>
                ) : (
                    <Button size="sm" title="Export" color="dark" className="buttonGroupSpacing float-right" onClick={() => this.downloadReport()}><FontAwesomeIcon icon="download" /></Button>
                )}
              </ButtonGroup>
            ) : null}
          </Col>
        </Row>

        {prodPlan &&
          <Row className="p-2">
            <Col xs="2">
              <Collapse isOpen={this.state.collapsePending}>
                <div className="mb-2">
                  <span className="boldText"> Product Type:</span>
                  <Select
                    className="pageTitleItem"
                    closeMenuOnSelect
                    isMulti={false}
                    options={this.state.productTypeList}
                    onChange={(e) => this.onChangeFilter({
                      filterName: "productTypeId",
                      value: e.value,
                      label: e.label,
                      filteredDisplay: "productTypeId"
                    })}
                    value={filterHelper.getSelectValue(
                      "productTypeId",
                      this.state.filters
                    )}
                  />
                </div>
                <div>
                  <Select
                    className="pageTitleItem"
                    closeMenuOnSelect
                    value={resolveSelectedSortValue(
                      sortList,
                      this.state.sortColumn,
                      this.state.sortAscending
                    )}
                    isMulti={false}
                    options={sortList}
                    onChange={e => this.onSelectChange(e)}
                  />
                </div>
              </Collapse>
            </Col>
            <Col>
              <Collapse isOpen={this.state.collapsePending}>
                <Row>
                  <Col>
                    <Table size="sm" hover>
                      <thead>
                        <tr>
                          <th>Pending Product</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                      {this.state.pendingProductsList && this.state.pendingProductsList.list.length > 0 ?
                        this.state.pendingProductsList.list.map((product, index) => (
                          <tr
                            id={`drag-${index}`}
                            key={`pending-${index}`}
                            draggable="true"
                            className="dragItem"
                            onDragStart={(e) => this.drag(e, product.id, product.productSku)}
                          >
                            <td>
                              <span id={`product-${product.productId}`}>{product.productSku}</span>
                              <div className="detailTextNoSize">Days On Hand: {product.daysOnHand}</div>
                              <UCToolTip
                                key={`${index}${product.productId}`}
                                placement="bottom"
                                target={`product-${product.productId}`}
                                text={`${product.productName}`}
                              />
                            </td>
                              <td>
                                <span className="cbdmdBlueText mr-2 pointer">
                                <FontAwesomeIcon icon="arrows-alt" title="Drag to column" />
                                </span>
                                <span onClick={() => this.onDeletePending(product.id)}>
                                  <FontAwesomeIcon
                                    icon="trash-alt"
                                    className="cbdmdDangerText pointer "
                                    title="Remove from pending"
                                  />
                                </span>
                              </td>
                            </tr>
                          )) :
                          <tr>
                            <td>
                              No Records available
                              </td>
                          </tr>
                        }
                      </tbody>
                    </Table>
                    <Pager {...this.state.pendingProductsList} callBack={this.setPage} />
                  </Col>
                  <Col className="ml-2 mt-2">
                    <span className="detailText">
                      To add product sku to planning form, select product by dragging it from the pending product table and dropping it into the desired planning column. 
                      'Days On Hand' is a calculated field that is determined by a products preferred demand days, inventory, production and sales count and is based on the selected planning date.
                    </span>
                  </Col>
                </Row>
              </Collapse>
            </Col>
            <Col xs="2" className="float-right">
              <Button size="sm" className="cbdmdPrimary float-right" onClick={() => this.collapsePending()}>
              <FontAwesomeIcon icon="clipboard-list" className="mr-2"/>
                {!this.state.collapsePending ? "Show Pending Products" : "Hide Pending Products"}
              </Button>
            </Col>
          </Row>
        }
        {this.state.message ? (
          <Row>
            <Alert2 color={this.state.messageColor} toggle={() => this.onDismiss()}>{this.state.message}</Alert2>
          </Row>
        ) : null}

        <Row className="p-2">
          <Col className="p-2">
            {prodPlan &&
              <Row className="fontSize24 ">
                <Col>
                  Production Plan -
                  <span className="greenHighlight ml-2 mr-2">Week of {dateHelper.formatStringDate(this.state.startDate, "MM.DD.YYYY")}</span>
                  {prodPlan.correctedAt &&
                    <span className="correctedText">
                      Corrected <span className="fontSize14">{prodPlan.correctedByUserFirstName} {prodPlan.correctedByUserLastName} {dateHelper.formatStringDate(prodPlan.correctedAt, "MM.DD.YYYY")}</span>
                    </span>
                  }
                </Col>
              </Row>
            }

            {this.state.editProductionPlan ? (
              <Table size="sm" responsive className="p-2">
                <thead>
                  <tr>
                    {this.generateTableHeader()}
                  </tr>
                </thead>
                <tbody>
                  {this.state.selectedWeekDays && this.state.selectedWeekDays.length ? (
                    this.state.selectedWeekDays.map((day, dIndex) => (
                      <tr key={`day-${dIndex}`} className="dragable" >
                        <td className="planDayCell">{day}</td>
                        {this.state.productPlanCategoryList.map(c => (
                          prodPlan !== null ?
                            <td id={`drop-${c.id}`} className="planDataCell dragablet" key={`cat-${c.id}`} onDrop={(e) => this.ondrop(e, day, c.id)} onDragOver={(e) => this.allowDrop(e)}>
                              <div>
                                <ul>
                                  {resolveItemsList(c.id, day, prodPlan.productionPlanItems).length ? (
                                    <React.Fragment>
                                      {resolveItemsList(c.id, day, prodPlan.productionPlanItems).map(item => (
                                        item.editing ? (
                                          <Input
                                            type="textarea"
                                            name="itemName"
                                            id="itemName"
                                            maxLength="100"
                                            value={this.state.editPlanItem.itemName || ""}
                                            onBlur={() => this.onSaveItem()}
                                            onChange={(e) => this.onInputChange(e)}
                                            ref={(input) => { this.itemNameInput = input; }}
                                          />
                                        ) : (
                                            <React.Fragment>
                                              <li key={`item-${item.id}`} onDoubleClick={() => this.onEdit(item.id, item)}>{item.itemName}</li>
                                            </React.Fragment>
                                          )
                                      ))}
                                      <li className={classnames({ "hoverDisplay": this.state.editPlanItem ? false : true }, "nobull")} title="Double Click to add new item" onDoubleClick={() => this.onAddNewItem(day, c.id)}></li>
                                    </React.Fragment>
                                  ) : (
                                      <li className="nobull hoverDisplay" title="Double Click to add new item"  onDoubleClick={() => this.onAddNewItem(day, c.id)}></li>
                                    )}
                                </ul>
                              </div>
                            </td>
                            : null
                        ))}
                      </tr>
                    ))
                  ) : null}
                </tbody>
              </Table>
            ) : (
              <div className="detailText centerText">
                {this.state.missingCategories ? (
                  <div>
                    <span className="text-warning mr-2"> <FontAwesomeIcon icon="exclamation-circle" /></span>
                    <span>Production Plan Categories have not been created and are required to generate planning worksheets. To create plan categories please use the admin screens.</span>
                  </div>
                ) : (
                  <span>No Production Plan Selected</span>
                )}
              </div>
            )}
          </Col>
        </Row>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/ProductionPlanning.js